import { render, staticRenderFns } from "./churchappIcons.vue?vue&type=template&id=0d96cf4b&"
import script from "./churchappIcons.vue?vue&type=script&lang=js&"
export * from "./churchappIcons.vue?vue&type=script&lang=js&"
import style0 from "./churchappIcons.vue?vue&type=style&index=0&id=0d96cf4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports